import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { General, Widgets } from "../../../../Constants/Constants";
import TotalSales from "../../Dashboard/ECommerce/TotalSales/TotalSales";
import Subscripation from "./Subscripation/Subscripation";
import Activities from "./Activities/Activities";
import TotalExpenditures from "./TotalExpenditures/TotalExpenditures";
import OrderThisMonth from "./OrderThisMonth/OrderThisMonth";
import ProductDelivery from "./ProductDelivery/ProductDelivery";
import RecentStatistics from "./RecentStatistics/RecentStatistics";
import TotalSalesGeneral from "./TotalSales/TotalSales";
import TotalVisitor from "./TotalVisitor/TotalVisitor";
import Visitors from "./Visitors/Visitors";

const GeneralContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Widgets} parent={General} />
      <Container fluid className="genral-widget">
        <Row>
          <TotalSales />
          <Subscripation />
          <Activities />
          <TotalExpenditures />
          <OrderThisMonth />
          <ProductDelivery />
          <RecentStatistics />
          <TotalSalesGeneral />
          <TotalVisitor />
          <Visitors />
        </Row>
      </Container>
    </>
  );
};

export default GeneralContainer;
